var ActionsComponent,
	ActionsPopupComponent;

(function ($, utils) {

	ActionsPopupComponent = Vue.component('action-popup-vue', {
		template: '#action-popup-vue',
		props: ['actions', 'actionPopupInit', 'currentSelectedAction', 'getDataArr'],
		data: function() {
			return {}
		},
		updated: function() {
			var index = $('.fancybox-container').data('test'),
					//indexCur = 0;
					// Если включить эту штучку, то при клике по имени магазина будет переход на конкретную акцию
					indexCur = $('#popupActions').find('.swiper-slide[data-index="' + index + '"]').index();

			this.actionPopupInit();

			var swiper   = new Swiper('#popupActions .swiper-container', {
				slidesPerView: 1,
				pagination: '#popupActions .swiper-pagination',
				paginationClickable: true,
				paginationBulletRender: function(swiper, index, className) {
					return '<span class="swiper-pagination-bullet"><svg class="icon__slideNav-item" width="21px" height="22px"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#slideNav-item"></use></svg></span>';
				},
				loop: false,
				nextButton: '#popupActions .swiper-button-next',
				prevButton: '#popupActions .swiper-button-prev',
				effect: 'fade',
				onInit: function() {
					var $textBlock = $('#popupActions').find('.popupActions__article');

					if($textBlock) {
						$textBlock.each(function() {
							$(this).mCustomScrollbar({
								autoHideScrollbar: true
							});
						});
					}

					utils.slidePreview('#popupActions', 1);
				},
				onSlideChangeEnd: function() {
					utils.slidePreview('#popupActions', 1);
				}
			});

			swiper.slideTo(indexCur, 0, true);
		}
	});

	var ActionsListComponent = Vue.component('action-list-vue', {
		template: '#action-list-vue',
		props: ['values', 'selectedActions', 'changeView'],
		data: function() {
			return {
				count: 0
			}
		}
	});

	var ActionsDetailComponent = Vue.component('action-detail-vue', {
		template: '#action-detail-vue',
		props: ['showDetail', 'closeDetail', 'actions', 'actionPopupInit', 'currentSelectedAction', 'getDataArr'],
		data: function() {
			return {}
		}
	});

	var ActionsPreviewComponent = Vue.component('action-preview-vue', {
		template: '#action-preview-vue',
		props: ['values', 'selectedActions'],
		data: function() {
			return {}
		}
	});

	var ActionsSearchComponent = Vue.component('action-search-vue', {
		template: '#action-search-vue',
		props: ['actions', 'selectedActions', 'changeView', 'result'],
		data: function() {
			return {}
		}
	});

	ActionsComponent = Vue.component('action-vue', {
	template: '#action-vue',
	components: {
		ActionsListComponent: ActionsListComponent,
		ActionsPreviewComponent: ActionsPreviewComponent,
		ActionsSearchComponent: ActionsSearchComponent,
		ActionsDetailComponent: ActionsDetailComponent
	},
	data: function() {
		return {
			id: '',
			storeFloor: '',
			hideBtn: false,
			coolActions: [],
			currentSelectedAction: '',
			currentView: '',

			values: [],
			actions: [],

			actionsUnique: [],

			actionsFiltered: [],
			result: false,

			viewType: 'preview',
			search: '',
			switchData: [
				{view: 'preview', text: 'Превью', icon: 'wc'},
				{view: 'list', text: 'Список', icon: 'eye'}
			],
			hideSpinner: false
		}
	},

	mounted: function() {
		this.mobile();
	},

	methods: {
		mobile: function() {
			var that = this,
				$box = $('.box_blockActions'),
				$search = $box.find('.search'),
				$detailActions = $('.blockActions__detail'),

				isMobile = function() {
				if (app.sizes.width < app.mobileTo) {
					that.switchData = [{view: 'preview', text: 'Акции', icon: 'promo'}, {view: 'list', text: 'Список', icon:'list'}];
					$('.blockActions__templates').prepend($search);
					$search.addClass('fade-item');
					$('.content').append($detailActions);
				} else {
					that.switchData = [{view: 'preview', text: 'Превью'}, {view: 'list', text: 'Список'}];
					$('.blockActions__left .blockActions__wrapp').append($search);
					$search.removeClass('fade-item');
				}
			};

			isMobile();
		},

		gotoMap: function() {
			var arr = {
				id: '',
				floor: ''
			};
			arr.id = this.id;
			arr.floor = this.storeFloor;
			return arr;
		},

		getDataArr: function(storeId, floor) {
			this.id   = storeId;
			this.storeFloor  = floor;
		},

		doSearch: CommonHelpers.debounce(function(str) {
			var filtered = [],
				result = false;

			str = str.trim().toLowerCase();

			if(this.actionsUnique) {
				$.each(this.actionsUnique, function(i, cat) {
					var temp = {catName: cat.catName, catSubTitle: cat.catSubTitle, actions: []};

					cat.actions.forEach(function(action) {
						//var indexStr = action.storeName.trim().toLowerCase().indexOf(str, 0);

						//if(indexStr > -1 && indexStr <= 0) {
						if(action.storeName.toLowerCase().indexOf(str) !== -1) {
							temp.actions.push(action);
							result = true;
							filtered[i] = temp;
						}
					});
				});
			}

			this.viewType = 'search';
			this.result = result;
			this.actionsFiltered = $.grep(filtered, function(n) {
				return (n);
			}); // удалить пустые элементы массива

			this.$nextTick(function() {
				// Инит скрола для поиска
				this.scrollerInit('search');
			});

		}, 300),

		changeView: function(type) {
			var that = this;
			this.viewType = type;

			if (type == 'preview') this.search = [];

			var isMobile = function() {
				if (app.sizes.width < app.mobileTo) { // подтянуть скролл наверх в режиме списка for mobile
					if (type == 'list') {

						$('html, body').animate({
							scrollTop: $('.box_blockActions').offset().top - $('.header__left').outerHeight()
						}, 500, function(){
							$('html, body').addClass('overflow--list');
						});

						$(window).on('resize', function(){
							if (that.viewType == 'list' || that.viewType == 'search') {
								$('html, body').removeClass('overflow--list').animate({
									scrollTop: $('.box_blockActions').offset().top - $('.header__left').outerHeight()
									}, 0, function(){
										$('html, body').addClass('overflow--list');
								});
							}
						});
					} else {
						$('html, body').removeClass('overflow--list');
						$(window).scrollTop($('.box_blockActions').offset().top - $('.header__left').outerHeight());
					}
				}
			};

			this.$nextTick(function() {
				// this.actionSliderInit(type); // зачем было?
				isMobile();
			});
		},

		getData: function() {
			var url = '/static/components-assets/blockActions/data.json';

			if(CommonHelpers.isDev('gold-babylon-static.denode.ru'))
				url = 'static/components-assets/blockActions/data.json';

			if(!this.values.length) {
				this.$http
					.get(url, {
						params: {
							action: 'getActions'
						}
					})
					.then(function(response) {
						var actions = [];

						var that = this;

						var img1Src = '',
							img2Src = '';

						this.values = response.body.data;

						// Формируем массив магазинов без повторов
						$.each(that.values, function(a, el1) {
							var shopIds = [];

							// Все уникальные имена магазинов в одной категории
							$.each(el1.actions, function(b, el2) {
								shopIds[el2.shopId] = true;
								//shopIds[el2.shopId] = true;
							});

							// Проходимся по массиву с именами магазинов
							for(var shopId in shopIds) {

								// Проходимся по акциям в данной категории
								//for(var ii = 0; ii < el1.actions.length; ii++) {
								$.each(el1.actions, function(ii, action) {
									if(shopIds[shopId] && (shopId == action.shopId)) {
									//if(shopIds[shopId] && (shopId == action.shopId)) {

									// для for
									//if(shopIds[shopId] && shopId == el1.actions[ii].shopId) {
										that.values[a].actions[ii].iAmBird = true; // Ставим флаг первого элемента
										shopIds[shopId] = false; // С этим магазом мы работали, больше его трогать не будем
									}
								});
							}
						});

						this.actionsUnique = this.values;

						// Формирование объекта с ссылками на изображение и его состояние - загружено или нет
						$.each(response.body.data, function(i, categories) {

							// Изображения первых двух акций
							if(i === 0) {
								img1Src = categories.actions[0].actionImg;
								if (categories.actions[1]) img2Src = categories.actions[1].actionImg;
							}

							if ((i === 1) && (img2Src.length === 0)) img2Src = categories.actions[0].actionImg;

							$.each(categories.actions, function(i, action) {
								actions.push(action);
							})
						});

						// Меня заставили это написать, извините!
						// Получить уникальные объекты по свойству
						var result = actions.reduce(function(memo, e1) {

							var matches = memo.filter(function(e2) {
								return e1.id == e2.id;
							});

							if(matches.length == 0)
								memo.push(e1);

							return memo;
						}, []);

						// Сортировка акций - от новых до старых
						result.
							sort(function(obj1, obj2) {
								var a = parseInt(obj1.sort) || 0,
										b = parseInt(obj2.sort) || 0;

								if(a < b) return 1;
								if(a > b) return -1;
							});

							this.actions = result;

						var objImages = [
							{
								loaded: false,
								src: img1Src
							},
							{
								loaded: false,
								src: img2Src
							}
						];

						CommonHelpers.checkImgLoading(objImages)
						.then(function() {
							that.doAnimation();
						});

						this.$nextTick(function() {
							this.actionPopupInit();
							this.actionSliderInit();
						});

						// Инит скрола для списка
						this.scrollerInit('list');
					},
					function(response) { // Error.
						console.log('An error occurred.');
					}
				);
			}
		},

		doAnimation: function() {
			var $targetSlide = $('.blockActionsSlider[data-view="preview"]');
			$targetSlide.find('.fade-item').showItem(450);

			if (app.sizes.width < app.mobileTo) $('.box_blockActions .search').showItem(450);

			this.hideSpinner = true;
		},

		scrollerInit: function(type) {
			type = type || '';

			var $box     = $('.blockActions__right'),
					$scroller = $box.find('[data-view="' + type + '"] .js-custom-scroll'),
					$prev     = $box.find('[data-view="' + type + '"] .js-prev-scroll'),
					$next     = $box.find('[data-view="' + type + '"] .js-next-scroll');

			if (app.sizes.width > app.mobileTo) app.utils.scroller($scroller, $prev, $next); // кастомный скролл выключить для мобил
		},

		actionSliderInit: function(type) {
			var $box      = $('.box_blockActions'),
					$slider   = $box.find('.blockActionsSlider');

			$slider.each(function(i, el) {
				var dataSlider = $(el).data('view');

				if (dataSlider === 'preview')
					app.utils.swiper(el, 2, 'slide', true, true);

					$(window).on('resize', function(){
						app.utils.swiper(el, 2, 'slide', true, true);
					});
			});
		},

		selectedActions: function(shopId, id) {
			this.coolActions = this.actions.filter(function(el) {
				return shopId === el.shopId;
			});

			this.$nextTick(function() {
				if (app.sizes.width < app.mobileTo) {
					this.showDetail(id); // показать детальную for mobile
				}
			});
			//console.log('this.coolActions', this.coolActions);
			//console.log(this.actions);
		},

		showDetail: function(id) {
			var $detail = $('.blockActions__detail'),
				$inner = $detail.find('.blockActions__inner'),
				$items = $detail.find('.blockActionsList__item'),
				$opened = $items.filter('.open'),
				$content = $opened.find('.blockActionsList__article'),
				$activeAction = $items.filter('[data-index="'+id+'"]'),
				$img = $items.find('.blockActionsList__img'),
				width = $items.width(),
				that = this,

				open = function($item){ // развернуть
					var $content = $item.find('.blockActionsList__article');
					$item.addClass('open');
					$content.animate({ opacity:1 }, { duration:400, queue:false });
					$content.slideDown(450);
				},

				close = function($item, dur){ // свернуть
					var $content = $item.find('.blockActionsList__article');
					$item.removeClass('open');
					$content.animate({ opacity:0 }, { duration:400, queue:false });
					$content.slideUp(450);
				};

			$detail.addClass('open');
			$inner.scrollTop(0);
			setTimeout(function(){
				$('html, body').addClass('overflow--detail');
			}, 500);

			var detail = document.getElementById('blockActions__detail');
			var mc = new Hammer(detail);

			mc.on('swiperight', function() {
				that.closeDetail();
			});

			$img.height(width); // чтобы блок с баннером был квадратный

			$(window).on('resize', function(){
				var width = $items.width();
				$img.height(width);
			});

			$.each($items, function(){ // аккордеон
				var $item = $(this),
					$header = $item.find('.blockActionsList__header');

				$header.off('click');
				$item.data('part', { close:close, open:open });

				$header.on('click', function(){
					var $opened = $items.filter('.open');
					if ($opened.is($item)) {
						close($opened);
					} else {
						if ($opened.length) $opened.data('part').close($opened);
						open($item);
					}
				});
			});

			// сворачиваем ранее открытые акции
			$opened.removeClass('open');
			$content.animate({ opacity:0 }, { duration:0, queue:false });
			$content.slideUp(0);

			$inner.animate({ // возвращаем скролл в начало
				scrollTop: 0
			}, 0, function(){
				if ($activeAction && $activeAction.length != 0) {
					open($activeAction); // открываем текущую акцию

					setTimeout(function(){
						$inner.animate({
							scrollTop: $activeAction.position().top // прокручиваем до выбранной акции
						}, 450);
					}, 500);
				}
			});
		},

		closeDetail: function() {
			$('html, body').removeClass('overflow--detail');
			$('.blockActions__detail').removeClass('open');
			$(window).scrollTop($('.box_blockActions').offset().top - $('.header__left').outerHeight());
		},

		actionPopupInit: function() {
			var init = false,
				that = this;

			var $box = $('.box_blockActions'),
				$loading = $box.find('.fancybox-loading');

			$('.blockActions__right').on('click', '.js-action', function(e) {
				e.preventDefault();

				$.fancybox.close(true);

				var $item = $(this),
						href  = $item.attr('href'),
						index = $item.data('index');

				this.currentSelectedAction = index;

				// спокойствие! всё под контролем
				if(!init) {
					if (app.sizes.width > app.mobileTo) {
						$.fancybox.open($(href), {
							beforeShow: function() {
								var $fancyContainer = $('.fancybox-container'),
										$popupActions = $('#popupActions');

								$fancyContainer.addClass('simple-popup');
								$fancyContainer.attr('data-test', index);

								var width = $popupActions.width();
								$popupActions.height(width/2);

								$(window).on('resize', function(){
									var width = $popupActions.width();
									$popupActions.height(width/2);
								});
							},
							afterShow: function() {
								init = true;
							}
						});
					}
				}
			});

			// Переход к карте
			var $gotoMap = $('#popupActions').find('.js-gotoMap');

			$gotoMap.on('click', function() {
				$.fancybox.close(true);
				var arr = vueApp.$refs.action.gotoMap();
				CommonHelpers.searchMap(null, arr);
			});
		}
	}
});
})(jQuery, app.utils);
